module.exports = __webpack_public_path__ + "static/media/PR_01_A.b6206b3c.png";